import * as CONSTANTS from '../../constants';
import { post } from '../../utils/apiUtils';

export function getCandidateReminderList() {
  return post(CONSTANTS.getCandidateReminderListURL);
}

export function createCandidateReminder(reminder) {
  return post(CONSTANTS.createCandidateReminderURL, reminder);
}

export function markCandidateRemindersAsDone(candidateReminderIds) {
  const payload = {
    candidateReminderIds
  };
  return post(CONSTANTS.markCandidateRemindersAsDoneURL, payload);
}

export function deleteCandidateReminders(candidateReminderIds) {
  const payload = {
    candidateReminderIds
  };
  return post(CONSTANTS.deleteCandidateRemindersURL, payload);
}
